module.exports = __webpack_public_path__ + "img/16.f04c9890.jpg";